(() => {
  // Show the cookie consent banner
  const showConsentBanner = () => {
    const banner = document.querySelector('[js-cookie-banner="banner"]');
    if (banner) {
      banner.style.display = "flex";
    }
  };

  // Hide the cookie consent banner
  const hideConsentBanner = () => {
    const banner = document.querySelector('[js-cookie-banner="banner"]');
    if (banner) {
      banner.style.display = "none";
    }
  };

  // Handle acceptance of cookies
  const acceptCookies = () => {
    if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
      window.Shopify.customerPrivacy.setTrackingConsent(true, hideConsentBanner);
    } else {
      hideConsentBanner();
    }
  };

  // Handle declination of cookies
  const declineCookies = () => {
    if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
      window.Shopify.customerPrivacy.setTrackingConsent(false, hideConsentBanner);
    } else {
      hideConsentBanner();
    }
  };

  // Attach event listeners to consent buttons
  const attachEventListeners = () => {
    const acceptButton = document.querySelector('[js-cookie-button="accept"]');
    const declineButton = document.querySelector(
      '[js-cookie-button="decline"]',
    );

    if (acceptButton) acceptButton.addEventListener("click", acceptCookies);
    if (declineButton) declineButton.addEventListener("click", declineCookies);
  };

  // Initialisation function
  const init = () => {
    attachEventListeners();

    // Check for testing override query parameter or Shopify Theme Editor
    const urlParams = new URLSearchParams(window.location.search);
    const isTestMode =
      urlParams.has("preview_cookies") ||
      urlParams.has("cookie_test") ||
      window.Shopify?.designMode;

    if (isTestMode) {
      showConsentBanner();
      return;
    }

    // Check if Shopify features loader is available
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== "function") {
      return;
    }

    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      (error) => {
        if (error) {
          console.error("Failed to load consent tracking API:", error);
          return;
        }

        const privacy = window.Shopify.customerPrivacy;
        if (!privacy) return;

        const consentStatus =
          typeof privacy.currentVisitorConsent === "function"
            ? privacy.currentVisitorConsent()
            : "";
        const shouldDisplay =
          typeof privacy.shouldShowBanner === "function"
            ? privacy.shouldShowBanner()
            : false;

        // empty string for consentStatus indicates no choice has been made yet
        if (consentStatus === "" && shouldDisplay) {
          showConsentBanner();
        }
      },
    );
  };

  // Handle DOM ready even if script executed after DOMContentLoaded fired
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
